// Phone helpers for the +1XXXXXXXXXX format used by Dispatch features.
// The +1 prefix is locked: any input is normalized so that callers can't
// remove the prefix or paste a non-US number without it being corrected.

const MAX_LENGTH = 12; // "+1" + 10 digits

export const formatUsPhone = (raw: string): string => {
    let v = raw.replace(/[^0-9+]/g, '');
    if (!v.startsWith('+1')) {
        v = '+1' + v.replace(/^\+/, '');
    }
    if (v.length > MAX_LENGTH) {
        v = v.slice(0, MAX_LENGTH);
    }
    return v;
};

export const isValidUsPhone = (v: string): boolean => /^\+1\d{10}$/.test(v);
